var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddCircleRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Add Circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.7915 6.50033L6.49984 6.50033M6.49984 6.50033L9.20817 6.50033M6.49984 6.50033V3.79199M6.49984 6.50033L6.49984 9.20866",
    stroke: "#E52823",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 131",
    cx: 6.5,
    cy: 6.5,
    r: 4.875,
    stroke: "#E52823",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircleRed);
export default __webpack_public_path__ + "static/media/addCircleRed.6a2c4ea9e7cb39f317c5a9115556d6f6.svg";
export { ForwardRef as ReactComponent };